<template>
  <main class="auth-page auth-page--admin">
    <div class="auth-orb auth-orb--a" aria-hidden="true" />
    <div class="auth-orb auth-orb--b" aria-hidden="true" />
    <div class="auth-grid auth-grid--dark" aria-hidden="true" />

    <section class="auth-shell auth-shell--admin">
      <aside class="auth-hero auth-hero--admin">
        <div class="auth-brand">
          <img class="brand-mark brand-mark--admin" :src="logo" alt="佐成乐赚" />
          <span class="brand-word">LUBAO CONSOLE</span>
        </div>
        <h1 class="auth-title">佐成乐赚</h1>
        <p class="auth-lead">统一管理客户、应用、设备、额度与风控，保障投放链路稳定可控。</p>
        <ul class="auth-points">
          <li>
            <el-icon><User /></el-icon>
            <span>客户额度与投放状态实时掌控</span>
          </li>
          <li>
            <el-icon><Grid /></el-icon>
            <span>应用与广告位参数统一配置</span>
          </li>
          <li>
            <el-icon><Warning /></el-icon>
            <span>设备分组与风控记录全程可溯</span>
          </li>
        </ul>
      </aside>

      <div class="auth-form-wrap">
        <div class="auth-form-head">
          <p class="auth-badge">Administrator</p>
          <h2>管理员登录</h2>
          <p>仅限内部运营人员使用</p>
        </div>

        <el-form ref="formRef" :model="form" :rules="rules" label-position="top" @keyup.enter="submit">
          <el-form-item label="管理员账号" prop="username">
            <el-input
              v-model.trim="form.username"
              size="large"
              placeholder="请输入账号"
              :prefix-icon="User"
              clearable
            />
          </el-form-item>
          <el-form-item label="登录密码" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              size="large"
              show-password
              placeholder="请输入密码"
              :prefix-icon="Lock"
            />
          </el-form-item>
          <el-button type="primary" size="large" :loading="loading" class="auth-submit" @click="submit">
            登录后台
          </el-button>
        </el-form>

        <p class="auth-switch">
          入口仅供内部使用，请收藏本页地址
        </p>
      </div>
    </section>
  </main>
</template>

<script setup>
import { computed, inject, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { User, Lock, Grid, Warning } from '@element-plus/icons-vue'
import logo from '../assets/logo.png'

const admin = inject('admin')
const router = useRouter()
const loading = computed(() => admin.loading.value)

const formRef = ref()
const form = reactive({ username: '', password: '' })
const rules = {
  username: [{ required: true, message: '请输入管理员账号', trigger: 'blur' }],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
}

const submit = async () => {
  if (!(await formRef.value.validate().catch(() => false))) return
  await admin.login({ username: form.username, password: form.password })
  if (admin.token.value) router.push('/admin/dashboard')
}
</script>
